import { useEffect, useState } from 'react';
import { rage } from '~/rage';

const useBackendReady = () => {
	const [backendReady, setBackendReady] = useState(!rage.config.isStub());

	useEffect(() => {
		console.log('loading backend ', { isStub: rage.config.isStub() });

		if (rage.config.isStub()) {
			rage.backend
				.waitForInit()
				.then(() => {
					setBackendReady(true);
					console.log('backend loaded');
				})
				.catch((err) => rage.notifications.showException(err));
		} else {
			console.log('backend already loaded');
			setBackendReady(true);
		}
	}, []);

	return backendReady;
};

export { useBackendReady };
